define('features/overlayGameLauncher/stats/xpRandomMilestones/xpRandomMilestonesViewModel',[
    'knockout'
],
function (ko) {

    return function XPMilestonesViewModel (newAdventure, adventureStaticData, parentView, id) {

        var self = this;

        self.id = id || 'xpRandomMilestones';
        self.xp = newAdventure.summary.property('xp');

        self.viewSmall = 'features/overlayGameLauncher/stats/xpRandomMilestones/xpRandomMilestonesViewSmall';
        self.viewLarge = 'features/overlayGameLauncher/stats/xpRandomMilestones/xpRandomMilestonesViewLarge';

        self.cssBinding = ko.pureComputed(function () {
            var css = {
                'xp': true,
                'flex-horizontal': true,
                'random': true
            };

            return css;
        });

        self.viewBeltInfo = ko.observable(false);

        self.activate = function () {
            self.viewBeltInfo(false);
        };

        adventureStaticData.apply(this, []);

    };
});

